/* ============================================================
   VITASNOUT — Cinta transportadora EN MOVIMIENTO (tema Shopify)
   Opera sobre los .belt-item renderizados por Liquid.
   Flujo derecha→izquierda en bucle; la patita los atrapa al
   llegar a la izquierda y vuelven a entrar por la derecha.
   ============================================================ */
(function () {
  'use strict';
  function init() {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const hasGSAP = window.gsap && !reduce;

    const stage = document.querySelector('[data-conveyor]');
    if (!stage) return;
    const track = stage.querySelector('.belt-track');
    const pawArm = stage.querySelector('#paw-arm');
    const els = Array.from(track.children);
    if (!els.length) return;

    // envolver contenido en .belt-item__inner si no existe (robustez)
    els.forEach((el) => {
      if (!el.querySelector('.belt-item__inner')) {
        const inner = document.createElement('div');
        inner.className = 'belt-item__inner';
        while (el.firstChild) inner.appendChild(el.firstChild);
        el.appendChild(inner);
      }
    });
    const inners = els.map((e) => e.querySelector('.belt-item__inner'));

    let itemW = 200, gap = 60, step = 260;
    function measure() {
      itemW = els[0].offsetWidth || 200;
      gap = window.innerWidth < 760 ? 40 : 60;
      step = itemW + gap;
    }
    measure();

    const GRAB_X = 8;
    const items = els.map((el, i) => ({ el, inner: inners[i], x: GRAB_X + 30 + i * step, grab: false }));
    const rightmost = () => Math.max.apply(null, items.map((i) => i.x));
    const place = (it) => { it.el.style.transform = `translateX(${it.x}px)`; };

    if (reduce || !window.gsap) {
      items.forEach((it, i) => { it.x = GRAB_X + 20 + i * step; place(it); });
      let off = 0;
      const shift = (d) => { off += d; items.forEach((it) => { it.el.style.transform = `translateX(${it.x + off}px)`; }); };
      stage.querySelector('[data-cv-prev]') && stage.querySelector('[data-cv-prev]').addEventListener('click', () => shift(step));
      stage.querySelector('[data-cv-next]') && stage.querySelector('[data-cv-next]').addEventListener('click', () => shift(-step));
      return;
    }

    items.forEach(place);

    function grab(it) {
      it.grab = true;
      gsap.timeline()
        .to(pawArm, { x: 26, y: -12, rotation: -4, duration: .16, transformOrigin: 'left center', ease: 'power2.out' })
        .to(it.inner, { scale: 0, opacity: 0, duration: .22, transformOrigin: 'center bottom', ease: 'back.in(2)' }, '<0.02')
        .to(pawArm, { x: 0, y: 0, rotation: 0, duration: .34, ease: 'power2.inOut' })
        .add(() => recycle(it));
    }
    function recycle(it) {
      it.x = rightmost() + step;
      place(it);
      it.grab = false;
      gsap.fromTo(it.inner, { scale: 0, opacity: 0 }, { scale: 1, opacity: 1, duration: .4, ease: 'back.out(1.6)', delay: .08 });
    }

    const BASE = parseFloat(stage.dataset.speed) || 72;
    let speed = BASE, target = BASE, running = true, last = performance.now();

    function tick(now) {
      const dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      speed += (target - speed) * Math.min(1, dt * 6);
      if (running) {
        for (const it of items) {
          if (it.grab) continue;
          it.x -= speed * dt;
          if (it.x <= GRAB_X) grab(it); else place(it);
        }
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    stage.addEventListener('mouseenter', () => { running = false; });
    stage.addEventListener('mouseleave', () => { running = true; last = performance.now(); });

    let boostTO;
    function boost(v) { target = v; clearTimeout(boostTO); boostTO = setTimeout(() => { target = BASE; }, 1100); }
    const next = stage.querySelector('[data-cv-next]');
    const prev = stage.querySelector('[data-cv-prev]');
    next && next.addEventListener('click', (e) => { e.preventDefault(); running = true; boost(BASE * 3); });
    prev && prev.addEventListener('click', (e) => { e.preventDefault(); boost(12); });

    window.addEventListener('resize', measure);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
